export default "__VITE_ASSET__MnEpQCRW__"